/**
 * Created with IntelliJ IDEA.
 * User: refaelm
 * Date: 2/17/13
 * Time: 2:43 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};

    var _ = require('underscore');
    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var lpAgentConfig = require('web-agent-config/lpAgentConfig');
    var ViewController = require('web-agent-framework/ViewController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');

    var SoundManager = function (modelController) {
        this.applicationType = "SoundManager";
        var logger = WebAgentLogger.getLogger(this.applicationType);


        var soundTypes = {
//        ACCEPT_NEXT_CHAT:{fileName:"accept_chat"},
            NEW_CHAT_REQUEST: {fileName: "new_chat_in_queue"},
            NEW_LINE: {fileName: "new_line"},
            MOVE_TO_INACTIVE: {fileName: "end_chat"}
        };

        var LPViewMap = {
            audioTag: ".lpview_audio_tag"
        };

        var volume = 1;
        var soundsSupported;
        var enableSounds = true;
        var audioTagSupport;
        var audioFilenameExtension;

        var ringingCount = 0;
        this.init = function () {
            audioTagSupport = audioTagSupported();
            audioFilenameExtension = fileTypesSupported();
            soundsSupported = !!audioFilenameExtension;

            if (soundsSupported) { // Only HTML5 at the moment.
                for (var prop in soundTypes) {
                    if (soundTypes.hasOwnProperty(prop)) {
                        buildAndAppendAudioElement(soundTypes[prop]);
                    }
                }
            }

            modelController.bindModelParam('agent.chatsResumedCount', this.onResume, this);
//        lpTag.agent.onAcceptChat(handleAcceptChat);
        };

        this.onResume = function () {
            modelController.unbindModelParam('agent.chatsResumedCount', this.onResume, this);
            modelController.bindModelParam('chats', this.onChatAdded, this);

            var channel = webAgentStatics.COMMUNICATION_CHANNELS.QUEUE_ORB;
            lpTag.WebAgent.channel.bind(channel.name, channel.events.ringCountChange, ringingCountChanged.bind(this));
            lpTag.WebAgent.channel.bind(channel.name, channel.events.maxChatsChange, maxConcurrencyChange.bind(this));
        };

        this.onChatAdded = function (data) {
            if (data && data.newValue) {
                for (var chatId in data.newValue) {
                    var state = modelController.getModelParam('chats.' + chatId + '.chatInfo.state');
                    if (state !== 'ended' && state !== 'transferred') {
                        modelController.bindModelParam('chats.' + chatId + '.newChatLine.lines', newChatLine, this, false);
                        modelController.bindModelParam('chats.' + chatId + '.chatInfo.state', chatStateChanged, this, false);
                    }
                }
            }
        };

        this.toggleSounds = function () {
            enableSounds = !enableSounds;
        };

        this.isSoundsEnabled = function () {
            return (enableSounds === true);
        };

        function handleAcceptChat(data) {
            if (data && data.chatInfo && data.chatInfo.state && data.chatInfo.state !== "ended") {
                play(soundTypes.ACCEPT_NEXT_CHAT);
            }
        }

        function chatStateChanged(data) {
            if (data) {
                var chatId;
                if (data.key) {
                    var splitKeys = data.key.split('.');
                    if (splitKeys && splitKeys.length >= 1) {
                        chatId = splitKeys[1];
                    }
                }
                if (chatId) {
                    switch (data.newValue) {
//                case 'active' : play(soundTypes.ACCEPT_NEXT_CHAT); break;
                        case 'ended' :
                            modelController.unbindModelParam('chats.' + chatId + '.newChatLine.lines', newChatLine, this);
                            modelController.unbindModelParam('chats.' + chatId + '.chatInfo.state', chatStateChanged, this);
                            if (isInMyEngagementsOrAccepted(chatId)) {
                                play(soundTypes.MOVE_TO_INACTIVE);
                            }
                            break;
                    }
                }
            }
        }

        function newChatLine(data) {
            var playSound = false;
            var lines, chatId;
            if (data && data.newValue) {
                lines = data.newValue;
            }
            if (data && data.key) {
                var splitKeys = data.key.split('.');
                if (splitKeys && splitKeys.length >= 1) {
                    chatId = splitKeys[1];
                }
            }
            if (lines) {
                for (var i = 0; i < lines.length; i++) {
                    if (lpTag.WebAgent.logicController.isLineNeedToBeNotified(lines[i], this.chatId)) {
                        playSound = true;
                    }
                }
            }
            if (playSound) {
                if (isInMyEngagementsOrAccepted(chatId)) {
                    play(soundTypes.NEW_LINE);
                }
            }
        }

        function isInMyEngagementsOrAccepted(chatId) {
            return (lpTag.WebAgent.logicController.isInMyEngagements(chatId) || lpTag.WebAgent.logicController.isAcceptedEngagementByChatId(chatId)) && !lpTag.WebAgent.logicController.isSimulatedEngagement(chatId);
        }

        function maxConcurrencyChange(isMaxChatsReached) {
            if (!isMaxChatsReached) {
                if (lpTag.WebAgent.queueOrbController.canAcceptChat()) {
                    play(soundTypes.NEW_CHAT_REQUEST);
                }
            }
        }

        function ringingCountChanged(data) {
            if (data && typeof data.count !== 'undefined') {
                var currentRingingCount = data.count;

                if (currentRingingCount > ringingCount) {
                    if (lpTag.WebAgent.queueOrbController.canAcceptChat()) {
                        play(soundTypes.NEW_CHAT_REQUEST);
                    }
                }

                ringingCount = currentRingingCount;
            }
        }

        function play(soundType) {
            logger.debug('play request for sound: ' + soundType.fileName + ' - canPlay: ' + soundType.canPlay + ' readyState:' + (soundType.audioTag && soundType.audioTag.readyState), "play");
            if (soundsSupported && enableSounds && soundType.audioTag) {
                if (audioTagSupport) {
                    if (soundType.canPlay && soundType.audioTag.readyState >= 2) {
                        soundType.audioTag.volume = volume;
                        soundType.audioTag.play();
                    } else {
                        logger.warn('cannot play sound - canPlay: ' + soundType.canPlay + ' - readyState: ' + (soundType.audioTag && soundType.audioTag.readyState), "play");
                    }
                } else {
                    soundType.audioTag.controls.play();
                }
            }
        }

        function buildAndAppendAudioElement(soundType) {
            if (!soundType.fileName || !lpAgentConfig || !lpAgentConfig.audioDir) {
                return;
            }

            var templateFile;
            if (audioTagSupport) {  //audio object for HTML5supported browsers
                templateFile = "LP_audio_tag.html";
            }
            else {                 //IE8 object
                templateFile = "LP_audio_object.html";
            }

            var element = ViewController.prototype.createView({
                templateFile: templateFile,
                target: document.body,
                hidden: true
            });

            soundType.audioTag = ViewController.prototype.getFirstElement(LPViewMap.audioTag, element);
            if (soundType.audioTag) {
                var source = lpAgentConfig.audioDir + "/" + soundType.fileName + "." + audioFilenameExtension;
                if (audioTagSupport) {
                    soundType.audioTag.src = source;
                    loadAudioResource(soundType);
                } else {
                    soundType.audioTag.url = source;
                }
            }
        }

        function loadAudioResource(soundType) {
            var hasCanPlayEvent = !_.isUndefined(soundType.audioTag.oncanplaythrough);
            var hasLoadFunction = _.isFunction(soundType.audioTag.load);

            logger.debug('loading audio resource: hasCanPlayEvent: ' + hasCanPlayEvent + ' hasLoadFunction: ' + hasLoadFunction, 'loadAudioResource');

            if (hasCanPlayEvent && hasLoadFunction) {
                logger.debug('using load function to load sound and event to indicate ready state.', 'loadAudioResource');
                soundType.audioTag.oncanplaythrough = function () {
                    logger.debug('sound is ready to play', 'oncanplaythrough');
                    soundType.canPlay = true;
                };
                soundType.audioTag.load();
            } else {
                logger.debug('using invocation of "play" method to load the resource.', 'loadAudioResource');
                setTimeout(function () {
                    soundType.canPlay = true;
                    soundType.audioTag.volume = 0;
                    soundType.audioTag.play();
                }, 10);
            }
        }

        function audioTagSupported() {
            var audioElementTag = document.createElement('audio');
            var isSupported = !!audioElementTag.canPlayType;

            audioElementTag = null;
            return isSupported;
        }

        function fileTypesSupported() {
            var supportedFileTypes;
            var mp3, wav;

            if (audioTagSupport) {
                var audioElementCheckSupported = document.createElement('audio');
                mp3 = audioElementCheckSupported.canPlayType('audio/mpeg;').replace(/^no$/, '');
                wav = audioElementCheckSupported.canPlayType('audio/wav; codecs="1"').replace(/^no$/, '');
                audioElementCheckSupported = null;

                if (wav === "probably") {
                    supportedFileTypes = "wav";
                } else if (mp3 === "probably" || mp3 === "maybe") {
                    supportedFileTypes = "mp3";
                }
            } else {
                supportedFileTypes = "mp3";
            }

            return supportedFileTypes;
        }
    };


    return SoundManager;

});
